import api from './apiClient';
import { ApiResponse } from 'shared/types/api';

export interface SecurityPasswordPolicy {
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireNumbers: boolean;
  requireSpecial: boolean;
}

export interface SecurityLockoutPolicy {
  maxAttempts: number;
  lockoutMinutes: number;
}

export interface SecurityPolicy {
  password: SecurityPasswordPolicy;
  lockout: SecurityLockoutPolicy;
  updatedAt?: string;
}

export interface SecurityAuditEntry {
  id: string;
  action: string;
  user: string;
  ipAddress: string | null;
  success: boolean;
  timestamp: string;
}

export interface SecurityStatus {
  passwordPolicy: boolean;
  httpsActive: boolean;
  auditActive: boolean;
  bruteForceProtection: boolean;
  twoFactorEnforced: boolean;
  rateLimiting: boolean;
}

export interface SecurityPolicyPayload {
  policy: SecurityPolicy;
  recentAudit: SecurityAuditEntry[];
  status: SecurityStatus;
}

/** super_admin-only platform security policy. */
export const securityPolicyApi = {
  get: (): Promise<ApiResponse<SecurityPolicyPayload>> =>
    api.get('/security-policy'),

  update: (
    body: { password?: Partial<SecurityPasswordPolicy>; lockout?: Partial<SecurityLockoutPolicy> },
  ): Promise<ApiResponse<SecurityPolicy>> => api.put('/security-policy', body),
};

export default securityPolicyApi;
